import { Typography } from "@/design-system/Atoms";
import { AccordionList } from "@/design-system/Molecules";
import { ingredientsData } from "@/design-system/Organisms/TrimixWhyItWorksSection/ingredients.data";
import { LinkArrowButton } from "@/design-system/Atoms/Button/LinkButton";
import { ROUTES } from "@/routes/routes.config";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";
import { useNavigate } from "react-router-dom";

export const TrimixWhyItWorksSection = () => {
  const navigate = useNavigate();
  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig();
  return (
    <section
      className="relative block w-full h-full bg-cover bg-no-repeat pt-[4.68rem] lg:pt-[10rem]"
      style={{
        backgroundImage: "url('/images/bg-shape-3.svg')",
        backgroundColor: "#f6f6f4",
      }}
    >
      <div className="relative pb-[4.68rem] lg:pb-[10rem]">
        <div className="container mx-auto">
          <div className="flex flex-wrap">
            <div className="w-full max-w-full flex-shrink-0 px-[0.75rem] lg:w-[41.666667%]">
              <Typography variant="categoryText" as="div" className="!mb-10">
                Defy Benefits
              </Typography>
              <Typography variant="sectionHeading" as="h2" className="!mb-10">
                <>
                  Trimix:<br></br>
                  <span className="text-gray-400">Why It Works</span>
                </>
              </Typography>
              <Typography
                variant="sectionDescriptionLarge"
                as="p"
                className="mb-10"
              >
                Trimix blends three powerful ingredients for potent results.
              </Typography>
              <div className="bg-[#eeedea] p-[1.875rem] rounded-[20px]">
                <AccordionList data={ingredientsData} />
              </div>
              <div className="inline-block pr-[0.75em] w-2xs  mt-10">
                <LinkArrowButton
                  href={`${ROUTES.PRODUCTS_BASE}/category/ICP`}
                  label="See Products"
                />
              </div>
            </div>
            <div className="w-full max-w-full flex-shrink-0 mt-[2.5rem] lg:mt-0 px-[0.75rem] lg:w-1/2 lg:ml-[8.333333%]">
              <img
                className="w-full object-cover"
                src="/images/trimix/img-trimix-benefits.png"
                alt="img-trimix-benefits"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="pb-[4.68rem] lg:pb-[10rem]">
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center justify-center">
            <div className="w-full max-w-full flex-shrink-0 px-[0.75rem] text-center lg:w-1/2">
              <img
                src="/images/trimix/img-trimix-overview2.png"
                alt="img-trimix-overview2"
                className="w-full object-cover rounded-[20px] mb-4 lg:mb-0 align-middle"
              />
            </div>
            <div className="w-full max-w-full flex-shrink-0 px-[0.75rem] lg:w-[41.666667%] lg:ml-[8.333333%]">
              <Typography
                variant="categoryText"
                as="div"
                className="mb-[3.125rem]"
              >
                Overview
              </Typography>
              <Typography variant="sectionHeading" as="h2" className="mb-10">
                <>
                  Access a Range of
                  <span className="text-gray-400"> Trimix Meds</span>
                </>
              </Typography>
              <Typography variant="sectionDescriptionLarge" as="p">
                The original Trimix formula works for most men. But DefyED
                offers expanded access to other forms of Trimix for men who
                struggle with severe ED.
              </Typography>
              <div className="inline-block pr-[0.75em] w-2xs  mt-10">
                <LinkArrowButton
                  href=""
                  label={ctaButtonConfig.text} 
                  onClick={() => {
                    if (ctaButtonConfig.text === "View Products") {
                      navigate(`${ROUTES.PRODUCTS_BASE}/category/ICP`);
                    } else {
                      ctaButtonConfig.action();
                    }
                  }}
                  loading={patientEntitlementsIsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrimixWhyItWorksSection;
